import { CaseDataQuestionMeta } from "./CaseDataQuestionMeta";
import { EdhConditionDisclosureResource } from "./EdhConditionDisclosureResource";
import { EdhResourceSupport } from "./EdhResourceSupport";
import { Link } from "./Link";
import { ListItemResource } from "./ListItemResource";
import { PicklistQuestionMeta } from "./PicklistQuestionMeta";

export enum DisclosureSource {
  NONE = "NONE",
  SEARCH = "SEARCH",
  SPECIFIED = "SPECIFIED",
  PICKLIST = "PICKLIST",
}

export enum QuestionType {
  HEADING = "HEADING",
  STANDARD = "STANDARD",
  CONDITIONAL = "CONDITIONAL",
  CASE_DATA = "CASE_DATA",
}

export enum AnswerType {
  YES_NO = "YES_NO",
  ENTER_DETAILS = "ENTER_DETAILS",
  PICKLIST = "PICKLIST",
  SELECTION = "SELECTION",
}

export interface BaseQuestionIdentifier {
  baseQuestionCode: string;
  caseId: string;
  interviewCode: string;
  interviewInstance: string;
  lifeInstance: string;
  stageCode: string;
}

export interface ConditionalQuestionMeta {
  childQuestionCodes: BaseQuestionIdentifier[];
  requiredDisclosureMade: boolean;
  requiresLinkedDisclosure: boolean;
}

export interface BaseQuestionResource {
  category: ListItemResource;
  code: string;
  answerRequiresAction: boolean;
  answerText?: string;
  answerType: AnswerType | null;
  answerValue?: string;
  baseQuestionHelp: string | null;
  caseDataQuestionMeta: CaseDataQuestionMeta;
  conditionalQuestionMeta: ConditionalQuestionMeta;
  disclosures?: EdhConditionDisclosureResource[] | null;
  disclosureSource: DisclosureSource | null;
  questionsImpactedByAnswerChange: BaseQuestionIdentifier[];
  questionText: string;
  parentConditionalQuestions: BaseQuestionIdentifier;
  picklistQuestionMeta: PicklistQuestionMeta;
  questionType: QuestionType;
  visible: boolean;
  _embedded: EdhResourceSupport | null;
  _links: Link[];
}
